/**
 * @author zhaoyan
 * 打开代理设置界面
 */

import Component from '../../../../lib/component';
import 'jquery-ui/themes/base/base.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/ui/widgets/dialog.js';
import './set-agent.scss';
import template from './set-agent.html';
import {UserInfoService} from "../../../../services/main/userInfoService"
import msgbox from "../../../../lib/msgbox";
import {PMAPI} from '../../../../lib/postmsg'
import {AutoSelect} from '../../../../components/util/autoSelect/autoSelect';
import '../../../../assets/scss/core/common.scss';
import TreeView from "../../../util/tree/tree";


let SetAgent = Component.extend({
    template:template,
    data:{
        selectedAgent:{},              //记录被选中的代理人
        originData:{},                     //请求到的原始数据
        formatData:[],
        selectedWorkflow:new Set(),        //记录被选中的工作流的id
        isOpen:0,                          //是否开启代理
        atSelect:{},
        itemDeleteChecked:false,
        agentListData:{},
        isEdit:false,
        currentProxy:false,
        treeIsEdit:false,
        savedAgentListData:{},
        isDel:false,
        isModify:false,
        userId:''
    },

    actions:{
        /**
         * 获取用户代理设置信息
         */
        initData:function () {
            let that = this;
            UserInfoService.getAgentData().then((result) => {
                this.hideLoading();
                if(result.success === 1){
                    that.data.originData = result;
                    $.extend(true,this.data.formatData,this.data.originData.data.workflow_list);
                    if(result.data.hasOwnProperty('user_id') && result.data.hasOwnProperty('agent_name')){
                        that.data.selectedAgent = {
                            id:result.data.user_id,
                            name:result.data.agent_name
                        };
                    }
                    let initAgent = '';
                    let initStatus = 0;
                    if(result.data.hasOwnProperty('settings')) {
                        this.data.agentListData = result.data.settings;
                        let agentListData = this.data.agentListData;
                        initAgent = Object.keys(agentListData)[0];
                        initStatus = initAgent ? agentListData[initAgent].status : 0
                        for(let i in agentListData) {
                            this.data.savedAgentListData[i] = {
                                status: agentListData[i]['status']
                            }
                            agentListData[i]['workflows'] = new Set(agentListData[i]['workflows']);
                            result.data.user_list.forEach(item => {
                                if(item.id == i){
                                    agentListData[i]['name'] = item.name;
                                }
                            })
                            agentListData[i]['workflows'].forEach(item=>{
                                this.data.selectedWorkflow.add(item);
                            })
                            agentListData[i]['workflow_list'] = this.data.formatData;
                            this.actions.appendItem(i,agentListData[i].name);
                            this.el.find('.agent-list-item:first-child').addClass('current')
                        }
                    }
                    this.data.userId = initAgent;
                    this.actions.initWorkflow(initAgent);
                    this.actions.initSwitch(initStatus);
                }else{
                    msgbox.alert("获取数据失败");
                }
            })
        },
        /**
        * 添加代理人按钮
        */
        appendItem: function (userId,name) {
            this.el.find('.modify-agent').css('display','inline-block');
            this.el.find('.agent-list').append(`<li class="agent-list-item" userId="${userId}">${name}<span class="item-delete icon-expert-error-msg"></span></li>`);
        },
        /**
         * 初始化代理流程列表
         */
        initWorkflow:async function (userId) {
            await this.actions.formatOriginData(this.data.formatData,userId);
            this.el.find('div.work-tree').empty();
            let treeView = new TreeView({data:{treeNodes:this.data.formatData,options:{
                callback:(event,node) => {
                    this.actions.selectNode(event,node,userId);
                    this.data.treeIsEdit = true;
                },
                treeType:"MULTI_SELECT",
                treeName:"workflow-tree",
                isSearch:true,
                withButtons: true
            },indent:0}});
            let $container = this.el.find("div.work-tree");
            treeView.render($container);
        },
        /**
         * 格式化代理流程数据，使用tree组件进行展示
         * @param nodes
         */
        formatOriginData:function (nodes,userId) {
            for(let i = 0; i < nodes.length; i++){
                let node = this.actions._adjustNode(nodes[i],userId);
                if(node.isSelect === true && (!node.hasOwnProperty("group"))){
                    this.data.selectedWorkflow.add(node.id);
                    this.data.agentListData[userId].workflows.add(node.id);
                }
                const children = node.children;
                if ( children && children.length > 0){
                    this.actions.formatOriginData(children,userId);
                }
            }
        },
        _adjustNode:function (originNode,userId) {
            const node = originNode;
            node.text = node.label;
            node.icon = '';
            node.selectedIcon = '';
            node.backColor = "#FFFFFF";
            node.selectable = false;
            if(userId){
                if(Array.from(this.data.agentListData[userId]['workflows']).includes(node.id)) {
                    node.isSelect = true;
                }else {
                    node.isSelect = false;
                }
            }else {
                node.isSelect = false;
            }
            node.state = {
                checked: node.isSelect,
                disabled: false,
                expanded: true,
                selected: false,
            };
            node.tags = ['available'];
            node.nodes = node.children;
            return node;
        },
        /**
         * 打开人员列表
         */
        getAgentList:function (isModify,userId) {
            PMAPI.openDialogByIframe('/iframe/agentList',{
                width: 400,
                height: 500,
                maxable: false,
                title: '选择人员'
            },{
                originData:this.data.originData,
                agentListData:this.data.agentListData,
                isModify:isModify,
                userId:userId
            }).then(res=>{
                if(res && !res.onlyclose){
                    let status = 0;
                    let workflows = new Set();
                    let savedAgentListData = this.data.savedAgentListData;
                    let agentListData = this.data.agentListData;
                    let isExist = false;
                    if(isModify) {
                        if(res.id == userId) {
                            return;
                        }
                        for(let i in savedAgentListData) {
                            if(i == res.id) {
                                isExist = true;
                                break;
                            }
                        }
                        status = agentListData[userId]['status'];
                        if(isExist) {
                            Array.from(agentListData[userId]['workflows']).forEach(item=>{
                                workflows = agentListData[res.id]['workflows'].add(item);
                            })
                        }else {
                            this.actions.appendItem(res.id,res.name);
                            workflows = agentListData[userId]['workflows'];
                        }
                        UserInfoService.deleteAgentData({agent_id:userId}).then((result) => {
                            if(result.success === 1) {
                                delete this.data.agentListData[userId];
                                delete this.data.savedAgentListData[userId];
                                this.el.find(`.agent-list-item[userid="${userId}"]`).remove();
                            }
                        })
                    }else {
                        this.actions.appendItem(res.id,res.name);
                    }
                    this.data.isEdit = true;
                    this.data.agentListData[res.id] = {
                        name:res.name,
                        status:status,
                        workflows: workflows,
                        workflow_list: this.data.formatData
                    }
                    $('.agent-list-item').removeClass('current');
                    this.el.find(`.agent-list-item[userid="${res.id}"]`).addClass('current');
                    this.data.userId = res.id;
                    this.actions.initSwitch(status);
                    this.actions.initWorkflow(res.id);
                }
            })
        },
        /**
         * 初始化代理开关
         * @param status
         */
        initSwitch:function (status) {
            if(status == 1){
                this.el.find('.close-radio')[0].checked = false;
                this.el.find('.open-radio')[0].checked = true;
            }else{
                this.el.find('.open-radio')[0].checked = false;
                this.el.find('.close-radio')[0].checked = true;
            }
        },
        /**
         * 仅保存被选中的具体工作流（叶子）节点的id，以是否具备group属性判断该节点是否为叶子节点
         * @param event
         * @param node
         */
        selectNode:function (event,node,userId) {
            if(event === 'select'){
                if(node.group && node.nodes && node.nodes.length > 0){
                    this.actions.addNodes(node.nodes,userId);
                }else{
                    this.data.selectedWorkflow.add(node.id);
                    if(userId){
                        this.data.agentListData[userId].workflows.add(node.id);
                    }
                }
            }else{
                if(node.group && node.nodes && node.nodes.length > 0){
                    this.actions.removeNodes(node.nodes,userId);
                }else{
                    this.data.selectedWorkflow.delete(node.id);
                    this.data.agentListData[userId].workflows.delete(node.id);
                }
            }
        },
        /**
         * 节点被勾选时，进行遍历处理
         * @param nodes
         */
        addNodes:function (nodes,userId) {
            for(let i=0; i<nodes.length; i++){
                if(!nodes[i].group){
                    this.data.selectedWorkflow.add(nodes[i].id);
                    this.data.agentListData[userId].workflows.add(nodes[i].id);
                }else{
                    let children = nodes[i].nodes;
                    if(children && children.length > 0){
                        this.actions.addNodes(children,userId);
                    }
                }
            }
        },
        /**
         * 节点去掉勾选时，进行遍历处理
         * @param nodes
         */
        removeNodes:function (nodes,userId) {
            for(let i=0; i<nodes.length; i++){
                if(!nodes[i].group){
                    this.data.selectedWorkflow.delete(nodes[i].id);
                    this.data.agentListData[userId].workflows.delete(nodes[i].id);
                }else{
                    let children = nodes[i].nodes;
                    if(children && children.length > 0){
                        this.actions.removeNodes(children,userId);
                    }
                }
            }
        },
        /**
         * 关闭代理开关
         * @param event
         */
        // closeSwitch:function (event) {
        //     this.data.isOpen = 0;
        //     if(this.data.userId && this.data.agentListData[this.data.userId].status == 1) {
        //         this.data.isEdit = true;
        //     }else {
        //         this.data.isEdit = false;
        //     }
        //     if(this.data.userId) {
        //         this.data.agentListData[this.data.userId].status = 0;
        //     }
        // },
        /**
         * 打开代理开关
         * @param event
         */
        // openSwitch:function (event) {
        //     this.data.isOpen = 1;
        //     if(this.data.userId && this.data.agentListData[this.data.userId].status == 0) {
        //         this.data.isEdit = true;
        //     }else {
        //         this.data.isEdit = false;
        //     }
        //     if(this.data.userId) {
        //         this.data.agentListData[this.data.userId].status = 1;
        //     }
        // },
        /**
         * 保存代理设置
         */
        saveAgent:function () {
            this.actions.filterWorkflows();
            if(this.data.currentProxy){
                this.data.isOpen = 0;
                let savedAgentListData = this.data.savedAgentListData;
                let agentListData = this.data.agentListData;
                for(let i in savedAgentListData) {
                    for(let j in agentListData) {
                        if(i == j){
                            savedAgentListData[i] = agentListData[j]['status'];
                            if(savedAgentListData[i] == 1) {
                                this.data.isOpen = 1;
                            }
                        }
                    }
                }
                this.showLoading();
                this.actions._sendAgent({
                    settings:JSON.stringify(savedAgentListData)
                });
            }
        },
        _sendAgent:function (data) {
            UserInfoService.saveAgentData(data).then((result) => {
                this.hideLoading();
                if(result.success === 1){
                    if(result.agent_state === 1){
                        msgbox.alert(`您所选择的代理人:${result.resigned}已离职，请重新选择`);
                    }else{
                        msgbox.alert(`设置代理成功，目前代理状态为：${this.data.isOpen ? "已开启":"未开启"}`);
                        UserInfoService.getSysConfig().then((result) => {
                            window.config.sysConfig = result;
                        });
                        agentSetting.hide();
                    }
                }else{
                    msgbox.alert("选择代理失败");
                }
            });
        },
        _sendCurrentAgent:function (data) {
            UserInfoService.saveCurrentAgentData(data).then((result) => {
                this.hideLoading();
                if(result.success === 1){
                    msgbox.alert("保存代理成功");
                    this.data.isEdit = false;
                    this.data.treeIsEdit = false;
                    this.data.savedAgentListData[data['agent_id']]=data['status'];
                }else{
                    if(result.duplicated_wf){
                        let duplicated = [];
                        for(let i in result.duplicated_wf) {
                            duplicated.push(i+'已代理给了'+result.duplicated_wf[i]);
                        }
                        msgbox.alert(`保存代理失败：${duplicated.join('，')}`);
                    }
                    else if (result.self_agent_wfs) {
                        msgbox.alert(`${result.agent_name}的${result.self_agent_wfs}流程已被您代理`);
                    }
                }
            });
        },
        /**
         * 删除代理设置
         */
        deleteAgentQuery:function(userId){
            UserInfoService.deleteAgentData({agent_id:userId}).then((result) => {
                if(result.success === 1) {
                    this.actions.deleteData(userId);
                }else {
                    msgbox.alert('删除代理失败');
                }
            })
        },
        deleteData:function (userId) {
            delete this.data.agentListData[userId];
            delete this.data.savedAgentListData[userId];
            this.el.find(`.agent-list-item[userid="${userId}"]`).remove();
            this.data.userId = this.el.find('.agent-list-item:last-child').attr('userid') || '';
            if(this.data.userId){
                $('.agent-list-item').removeClass('current');
                this.el.find(`.agent-list-item[userid="${this.data.userId}"]`).addClass('current');
                this.actions.initSwitch(this.data.agentListData[this.data.userId]['status']);
                this.actions.initWorkflow(this.data.userId);
                this.data.isEdit = false;
                this.data.treeIsEdit = false;
            }
        },
        /**
         * 编辑代理人
         */
        itemEdit: function () {
            if(!this.data.itemDeleteChecked){
                this.el.find('.agent-list').find('.item-delete').css('display','block');
                this.el.find('.edit').html(`<span class="edit-cancel">取消</span>`);
                this.data.itemDeleteChecked = !this.data.itemDeleteChecked;
            } else {
                this.el.find('.agent-list').find('.item-delete').css('display','none');
                this.el.find('.edit').html(`<i class="img agent-icon icon-agent-edit"></i> <span>编辑</span>`);
                this.data.itemDeleteChecked = !this.data.itemDeleteChecked;
            }
        },
        /**
         * 保存当前代理设置
         */
        saveCurrentProxy: function () {
            this.actions.filterWorkflows(true);
            if(this.data.currentProxy){
                let setting = {
                    agent_id:this.data.userId || '',
                    status: 0,
                    workflows:JSON.stringify(Array.from(this.data.agentListData[this.data.userId].workflows))
                };
                this.actions._sendCurrentAgent(setting);
            }
        },
        /**
         * 渲染当前选中代理设置
         * @param userId
         * @param el
         */
        renderListItem: function (userId,el) {
            el.siblings().removeClass('current');
            el.addClass('current');
            this.data.userId = userId;
            let status;
            if(this.data.agentListData[userId]){
                status = this.data.agentListData[userId]['status'];
            }
            this.actions.initSwitch(status);
            this.actions.initWorkflow(userId);
        },
        /**
         * 保存代理前的逻辑判断
         * @param isSaveCurrent
         */
        filterWorkflows: function (isSaveCurrent) {
            let agentListData = this.data.agentListData;
            let status = this.actions.currentStatus();
            if($.isEmptyObject(agentListData)){
                if(!this.data.isDel || isSaveCurrent) {
                    msgbox.alert("请选择一个代理人");
                    this.data.currentProxy = false;
                }else {
                    this.data.currentProxy = true;
                }
                return;
            }else {
                for(let i in agentListData) {
                    if(agentListData[i].workflows.size === 0) {
                        msgbox.alert("请选择至少一个流程");
                        this.data.currentProxy = false;
                        break;
                    }else if(!isSaveCurrent && this.data.userId && agentListData[this.data.userId] && (agentListData[this.data.userId]['status'] != status || this.data.treeIsEdit)){
                        msgbox.alert('请先保存当前代理设置');
                        this.data.currentProxy = false;
                        break;
                    } else {
                        agentListData[this.data.userId]['status'] = status;
                        this.data.currentProxy = true;
                    }
                }
            }
        },
        /**
         * 当前代理状态
         */
        currentStatus: function () {
            let status = 0;
            let checked = this.el.find('.close-radio')[0].checked;
            if(checked) {
                status = 0;
            }else {
                status = 1;
            }
            return status;
        },
        /**
         * 切换代理前检查当前代理状态
         */
        checkChangeValue: function () {
            let status = this.actions.currentStatus();
            let agentListData = this.data.agentListData;
            if(this.data.userId && !$.isEmptyObject(this.data.agentListData)) {
                if(agentListData[this.data.userId] && (agentListData[this.data.userId]['status'] != status || this.data.treeIsEdit || this.data.isEdit || agentListData[this.data.userId]['workflows'].size == 0)) {
                    this.data.isEdit = true;
                    msgbox.alert('请先保存当前代理设置');
                    return false;
                }else {
                    agentListData[this.data.userId]['status'] = status;
                    this.data.isEdit = false;
                    return true;
                }
            }else {
                return true;
            }
        }
    },
    binds:[
        {
            event:'click',
            selector:'.confirm-proxy',
            callback:_.debounce(function(){
                this.actions.saveAgent();       //保存代理设置
            },500)
        },
        // {
        //     event:'click',
        //     selector:'.close-radio',
        //     callback:function (event) {
        //         this.actions.closeSwitch(event);        //关闭代理
        //     }
        // },
        // {
        //     event:'click',
        //     selector:'.open-radio',
        //     callback:function (event) {
        //         this.actions.openSwitch(event);         //打开代理
        //     }
        // },
        {
            event:'click',
            selector:'.select-agent .add',
            callback:function (event) {
                let res = this.actions.checkChangeValue();
                if(res){
                    this.actions.getAgentList();      //选择代理人
                }
            }
        },
        {
            event:'click',
            selector:'.select-agent .edit',
            callback:function () {
                this.actions.itemEdit();
            }
        },
        {
            event:'click',
            selector:'.cancel-proxy',
            callback:function () {
                agentSetting.hide();
            }
        },
        {
            event:'click',
            selector:'.agent-list-item',
            callback:function (dom,event) {
                let userId = $(event.target).attr('userId');
                let res = this.actions.checkChangeValue();
                if(res && userId != this.data.userId){
                    this.actions.renderListItem(userId,$(event.target));
                }
            }
        },
        //删除代理人
        {
            event:'click',
            selector:'.item-delete',
            callback:function (dom,event) {
                this.data.isDel = true;
                let agentName = $(event.target).parent()[0].innerText;
                let userId = $(event.target).parent()[0].attributes["userId"].nodeValue;
                msgbox.confirm(`确定删除给${agentName}的代理设置？`).then(res =>{
                    if(res) {
                        let isSavedData = false;
                        for(let i in this.data.savedAgentListData) {
                            if(i == userId) {
                                isSavedData = true;
                                break;
                            }
                        }
                        isSavedData ? this.actions.deleteAgentQuery(userId): this.actions.deleteData(userId);
                    }else{
                        return;
                    }
                })
                event.stopPropagation();
            }
        },
        //保存当前代理设置
        {
            event:'click',
            selector:'.save-proxy',
            callback:function () {
                this.actions.saveCurrentProxy();
            }
        },
        //修改代理人
        {
            event:'click',
            selector:'.modify-agent',
            callback:function () {
                let res = this.actions.checkChangeValue();
                if(res){
                    this.actions.getAgentList(true,this.data.userId);
                }
            }
        },
    ],
    afterRender:function () {
        this.showLoading();
        this.actions.initData();
    },
    beforeDestory:function () {

    }
});

export const agentSetting = {
    el: null,
    show: function() {
        let component = new SetAgent();
        component.dataService = UserInfoService;
        this.el = $('<div class="set-agent-page">').appendTo(document.body);
        component.render(this.el);
        this.el.erdsDialog({
            title: '设置代理',
            width: 950,
            height: 600,
            modal: true,
            close: function() {
                $(this).erdsDialog('destroy');
                component.destroySelf();
            }
        });
    },
    hide: function () {
        this.el.erdsDialog('close');
    }
};






// WEBPACK FOOTER //
// app/components/main/personal-settings/set-agent/set-agent.js